import { PropsWithChildren } from 'react';

import { useWorkspaceQuery } from '@repo/api-client';
import {
  usePromotionStore,
  promotionSelector,
} from '@repo/editor/src/stores/promotionStore';
import { SubscriptionProvider } from '@repo/subscription/client';

import { useActiveWorkspaceId } from 'global/utils/workspace/useActiveWorkspaceId';

export const SubscriptionPackageProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const activeWorkspaceId = useActiveWorkspaceId({
    fallbackToPersonal: true,
  });
  const { data: activeWorkspace } = useWorkspaceQuery({
    workspaceId: activeWorkspaceId,
  });

  const showUpgradeModal = usePromotionStore(
    promotionSelector.showUpgradeModal
  );

  return (
    <SubscriptionProvider
      showUpgradeModal={showUpgradeModal}
      workspace={activeWorkspace ?? null}
    >
      {children}
    </SubscriptionProvider>
  );
};
